<template>
  <div id="app">
    <header class="masthead">
      <nav class="navbar navbar-expand-md">
        <div class="navbar-brand">
          <router-link to="/">
            <img
              class="brand-img"
              src="/assets/images/valhallaverse.webp"
              alt
            />
          </router-link>
          <button
            class="navbar-toggler float-right collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#mainNav"
            aria-controls="mainNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="icon-bar top-bar"></span>
            <span class="icon-bar middle-bar"></span>
            <span class="icon-bar bottom-bar"></span>
          </button>
        </div>

        <div class="masthead-line">
          <img class="line-img" src="/assets/images/menuline.webp" alt />
        </div>

        <div
          class="collapse navbar-collapse nav-masthead justify-content-center"
          id="mainNav"
        >
          <!-- Mobile Menu-->
          <div class="navbar-nav" v-if="$device.mobile">
            <router-link class="nav-link" to="/">Game</router-link>
            <a class="nav-link" style="opacity: 0.5">Marketplace</a>
            <router-link class="nav-link" :to="{ path: '/', hash: '#warriors' }">
              Warrior NFTs
            </router-link>
            <router-link
              class="nav-link"
              :to="{ path: '/', hash: '#skillcards' }"
            >
              Skill cards
            </router-link>
            <router-link
              class="nav-link"
              :to="{ path: '/', hash: '#partners' }"
            >
              Partners
            </router-link>
            <router-link class="nav-link" :to="{ path: '/', hash: '#tokens' }">
              Tokens
            </router-link>
            <router-link class="nav-link" to="/">Whitepaper</router-link>
          </div>

          <!-- Desktop Menu-->
          <div class="navbar-nav" v-else>
            <router-link class="nav-link" to="/">Game</router-link>
            <a class="nav-link" style="opacity: 0.5">Marketplace</a>
            <router-link
              class="nav-link"
              :to="{ path: '/details', hash: '#warriors' }"
            >
              Warrior NFTs
            </router-link>
            <router-link
              class="nav-link"
              :to="{ path: '/details', hash: '#skillcards' }"
            >
              Skill cards
            </router-link>
            <router-link
              class="nav-link"
              :to="{ path: '/details', hash: '#partners' }"
            >
              Partners
            </router-link>
            <router-link
              class="nav-link"
              :to="{ path: '/details', hash: '#tokens' }"
            >
              Tokens
            </router-link>
            <router-link class="nav-link" to="/">Whitepaper</router-link>
          </div>
        </div>
      </nav>
      <div class="social-links">        
        <a target="_blank" href="https://www.instagram.com/valhallaverse/"><fa :icon="['fab', 'instagram']" /></a>
        <a target="_blank" href="https://t.me/ValhallaVerseOfficial"><fa :icon="['fab', 'telegram']" /></a>
        <a target="_blank" href="https://twitter.com/ValhallaVerse"><fa :icon="['fab', 'twitter']" /></a>
        <a target="_blank" href="https://medium.com/@valhallaverse"><fa :icon="['fab', 'medium']" /></a>
        <!-- <a target="_blank" href="#"><fa :icon="['fab', 'youtube']" /></a> -->
      </div>
    </header>
    <router-view></router-view>
  </div>
</template>

<script>
import Leaves from '@/components/Leaves.vue';
export default {
  mounted() {
    let loader = this.$loading.show({
      backgroundColor: '#000',
      color: '#8e7355',
      opacity: 1,
    });
    this.$nextTick(() => {
      setTimeout(() => loader.hide(), 500);
    });
    $('.navbar-nav>a').on('click', function () {
      $('.navbar-collapse').collapse('hide');
    });
  },
  watch: {
    $route(to, from) {
      // do domething
      console.log(to.path);
    },
  },
  components: {
    Leaves,
  },
};
</script>

<style lang="scss">
#app {
  color: #fff;
}

.masthead {
  position: absolute;
  z-index: 9;
  width: 100%;
  background: linear-gradient(180deg, #333333 0.32%, rgba(51, 51, 51, 0) 100%);
  .navbar {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    align-items: center;
    padding: 0;
    .navbar-brand {
      margin-bottom: 0;
      min-width: 42.5%;
      margin-right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      @media (max-width: 767.98px) {
        text-align: left;
        float: left;
        height: 72px;
      }
      .brand-img {
        width: 74%;
        max-height: 135px;
        @media (max-width: 767.98px) {
          width: 85%;
        }
      }
    }
    .navbar-collapse {
      transition: none;
    }
    @media (max-width: 767.98px) {
      .navbar-nav {
        background: rgba(55, 55, 55, 0.9);
        height: calc(100vh - 80px);
        justify-content: space-evenly;
        align-items: center;
        transition: all 0.3s ease;
        opacity: 1;
      }
      &.collapse:not(.show) {
        display: none;
        .navbar-nav {
          opacity: 0;
        }
      }
    }
    .navbar-toggler-icon {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 238, 194, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
    }
    .navbar-toggler {
      border: none;
      background: transparent !important;
      color: rgba(0, 0, 0, 0.5);
      border-color: rgba(0, 0, 0, 0.1);
      &:hover {
        background: transparent !important;
      }
      .icon-bar {
        display: block;
        width: 25px;
        height: 2px;
        border-radius: 1px;
        transition: all 0.2s;
        background-color: rgba(255, 238, 194, 0.5);
      }
      .icon-bar + .icon-bar {
        margin-top: 5px;
      }
      .top-bar {
        transform: rotate(45deg);
        transform-origin: 10% 10%;
      }
      .middle-bar {
        opacity: 0;
      }
      .bottom-bar {
        transform: rotate(-45deg);
        transform-origin: 10% 90%;
      }
      &.collapsed {
        .top-bar {
          transform: rotate(0);
        }
        .middle-bar {
          opacity: 1;
        }
        .bottom-bar {
          transform: rotate(0);
        }
      }
    }
    .masthead-line {
      margin-top: -1rem;
      @media (max-width: 767.98px) {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
      }
      .line-img {
        max-width: 750px;
        width: 100%;
      }
    }
  }
  .social-links {
    position: absolute;
    right: 1rem;
    top: 1rem;
    z-index: 1;

    a {
      &:hover {
        color: rgb(255, 238, 194);
      }

      margin-left: 1rem;
      font-size: 1rem;
    }
    @media (max-width: 767.98px) {
      display: none;
    }
  }
}

.nav-masthead {
  width: 100%;
  @media (max-width: 767.98px) {
  }
  .nav-link {
    display: block;
    padding: 0.25rem 0;
    font-weight: 400;
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.75);
    background-color: transparent;
    position: relative;
    @media (max-width: 767.98px) {
      font-size: 1.5rem;
    }
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: none;
    }

    &:hover,
    &:focus {
      color: rgba(255, 255, 255, 1);
      &:after {
        background: url('/assets/images/menuline.webp') center no-repeat;
      }
    }

    + .nav-link {
      margin-left: 1rem;
      @media (max-width: 767.98px) {
        margin-left: unset;
      }
    }
  }

  .active {
    color: #fff;
    border-bottom-color: #fff;
  }
}
</style>
